export default {
  documentTitle: {
    login: "YSystem｜Login",
    dashboard: "YSystem｜Dashboard",
    post: "YSystem｜Post"
  },
  buttons: {
    logout: "Logout",
    add: "Add",
    delete: "Delete",
    reload: "Reload",
    backTop: "Back Top"
  },
  menus: {
    home: "Home",
    login: "Login",
    abnormal: "Abnormal Page",
    fourZeroFour: "404",
    fourZeroOne: "403",
    hsFive: "500"
  },
  status: {
    loading: "Loading..."
  },
  login: {
    username: "Username",
    password: "Password",
    login: "Login",
    usernameReg: "Please enter username",
    passwordReg: "Please enter password",
    passwordRuleReg:
      "The password format should be any combination of 8-18 digits",
    channelPh: "Please select channel",
  }
};
